// import { Component, OnInit } from '@angular/core';

// @Component({
//   selector: 'app-admin-generate-invoice',
//   templateUrl: './admin-generate-invoice.component.html',
//   styleUrls: ['./admin-generate-invoice.component.css']
// })
// export class AdminGenerateInvoiceComponent implements OnInit {

//   constructor() { }

//   ngOnInit(): void {
//   }

// }

// // new add 
// // import { Component, Inject } from '@angular/core';
// // import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
// // import { AdminService } from '../admin.service'; // adjust path
// // import { MatSnackBar } from '@angular/material/snack-bar';

// // @Component({
// //   selector: 'app-admin-generate-invoice',
// //   templateUrl: './admin-generate-invoice.component.html',
// //   styleUrls: ['./admin-generate-invoice.component.css']
// // })
// // export class AdminGenerateInvoiceComponent {
// //   invoiceData: any = {
// //     customer_name: '',
// //     invoice_date: new Date().toISOString().substring(0, 10),
// //     amount: 0,
// //   };

// //   isLoading = false;

  // constructor(
  //   public dialogRef: MatDialogRef<AdminGenerateInvoiceComponent>,
  //   @Inject(MAT_DIALOG_DATA) public data: any,
  //   private adminService: AdminService,
  //   private snackBar: MatSnackBar
  // ) {
  //   if (data) {
  //     this.invoiceData.customer_name = data.userInfo?.[0]?.name || '';
  //     this.invoiceData.amount = data.total_fare || 0;
  //   }
  // }

// //   prefillInvoiceData() {
// //     this.invoiceData = {
// //       invoice_number: `S9T-${this.data.trip_id}`,
// //       reference_number: this.data.trip_id,
// //       customer_name: this.data.userInfo[0]?.name || '',
// //       date: new Date().toISOString().substring(0, 10),
// //       due_date: this.calculateDueDate(30),
// //       payment_terms: 30,
// //       notes: 'Thanks for your business with S9 Trucks.',
// //       terms: 'Exemption certificate available on request.',
// //       line_items: [
// //         {
// //           item_order: 1,
// //           description: 'Transportation charges',
// //           rate: this.data.total_fare,
// //           quantity: 1,
// //           tax_id: '3091886000000032437',
// //         },
// //       ],
// //     };
// //   }

// //   calculateDueDate(days: number) {
// //     const date = new Date();
// //     date.setDate(date.getDate() + days);
// //     return date.toISOString().substring(0, 10);
// //   }

// //   generateInvoice() {
// //     this.isLoading = true;

// //     // this.adminService.generateInvoice(this.invoiceData).subscribe({
// //     //   next: (res: any) => {
// //     //     this.isLoading = false;
// //     //     this.snackBar.open('Invoice generated successfully!', 'OK', { duration: 3000 });
// //     //     this.dialogRef.close(res); // return API response to parent
// //     //   },
// //     //   error: (err) => {
// //     //     this.isLoading = false;
// //     //     this.snackBar.open('Failed to generate invoice', 'Close', { duration: 3000 });
// //     //     console.error('Invoice generation error:', err);
// //     //   }
// //     // });
// //   }

// //   close() {
// //     this.dialogRef.close();
// //   }
// // }


// // claude
// import { Component, OnInit } from '@angular/core';
// import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';

// interface LineItem {
//   item_order: number;
//   rate: string;
//   description: string;
//   quantity: string;
//   discount: string;
//   tax_id: string;
//   project_id: string;
//   tags: string[];
//   tax_exemption_code: string;
//   item_custom_fields: any[];
//   hsn_or_sac: string;
//   gst_treatment_code: string;
// }

// interface InvoicePayload {
//   invoice_number: string;
//   reference_number: string;
//   payment_terms: number;
//   payment_terms_label: string;
//   payment_options: {
//     payment_gateways: any[];
//   };
//   customer_id: string;
//   contact_persons: string[];
//   date: string;
//   due_date: string;
//   notes: string;
//   terms: string;
//   is_inclusive_tax: boolean;
//   line_items: LineItem[];
//   allow_partial_payments: boolean;
//   custom_fields: any[];
//   account_id: string;
//   is_discount_before_tax: boolean;
//   discount: number;
//   discount_type: string;
//   adjustment: string;
//   adjustment_description: string;
//   tax_exemption_code: string;
//   tax_authority_name: string;
//   zcrm_potential_id: string;
//   zcrm_potential_name: string;
//   pricebook_id: string;
//   template_id: string;
//   project_id: string;
//   documents: any[];
//   mail_attachments: any[];
//   billing_address_id: string;
//   shipping_address_id: string;
//   gst_treatment: string;
//   gst_no: string;
//   place_of_supply: string;
//   subject_content: string;
//   is_tcs_amount_in_percent: boolean;
// }

// @Component({
//   selector: 'app-admin-generate-invoice',
//   templateUrl: './admin-generate-invoice.component.html',
//   styleUrls: ['./admin-generate-invoice.component.css']
// })
// export class AdminGenerateInvoiceComponent implements OnInit {
//   invoiceForm!: FormGroup;
  
//   // Dropdown options
//   paymentTermsOptions = [
//     { value: 15, label: 'Net 15' },
//     { value: 30, label: 'Net 30' },
//     { value: 45, label: 'Net 45' },
//     { value: 60, label: 'Net 60' }
//   ];

//   accountOptions = [
//     { value: '3091886000000000462', label: 'Accounts Receivable' }
//   ];

//   taxOptions = [
//     { value: '3091886000000032437', label: 'GST 18%' },
//     { value: '', label: 'No Tax' }
//   ];

//   gstTreatmentOptions = [
//     { value: 'consumer', label: 'Consumer' },
//     { value: 'business_gst', label: 'Business - GST' },
//     { value: 'business_none', label: 'Business - None' }
//   ];

//   placeOfSupplyOptions = [
//     { value: 'TS', label: 'Telangana' },
//     { value: 'AP', label: 'Andhra Pradesh' },
//     { value: 'KA', label: 'Karnataka' },
//     { value: 'TN', label: 'Tamil Nadu' }
//   ];

//   constructor(private fb: FormBuilder) {}

//   ngOnInit(): void {
//     this.initializeForm();
//     this.setupCalculations();
//   }

//   initializeForm(): void {
//     this.invoiceForm = this.fb.group({
//       customer_id: ['', Validators.required],
//       customer_name: ['', Validators.required],
//       invoice_number: ['S9T-000003', Validators.required],
//       reference_number: [''],
//       date: [this.getCurrentDate(), Validators.required],
//       payment_terms: [30, Validators.required],
//       due_date: [this.getDueDate(30), Validators.required],
//       account_id: ['3091886000000000462', Validators.required],
//       salesperson: [''],
//       subject_content: [''],
//       line_items: this.fb.array([this.createLineItem()]),
//       notes: ['Thanks for your business with ?'],
//       terms: ['exemption certificate available on request.'],
//       discount: [0],
//       discount_type: ['percent'],
//       tds: [0],
//       tcs: [0],
//       adjustment: [''],
//       adjustment_description: ['Adjustment'],
//       gst_treatment: ['consumer'],
//       gst_no: [''],
//       place_of_supply: ['TS'],
//       billing_address_id: [''],
//       shipping_address_id: [''],
//       contact_persons: [[]],
//       template_id: ['3091886000000032184'],
//       is_inclusive_tax: [false],
//       is_discount_before_tax: [true],
//       allow_partial_payments: [false],
//       is_tcs_amount_in_percent: [true]
//     });
//   }

//   createLineItem(): FormGroup {
//     return this.fb.group({
//       item_order: [1],
//       description: ['', Validators.required],
//       quantity: ['1.00', [Validators.required, Validators.min(0.01)]],
//       rate: ['0.00', [Validators.required, Validators.min(0)]],
//       discount: ['0'],
//       tax_id: [''],
//       hsn_or_sac: [''],
//       project_id: [''],
//       tags: [[]],
//       tax_exemption_code: [''],
//       item_custom_fields: [[]],
//       gst_treatment_code: [''],
//       amount: [0]
//     });
//   }

//   get lineItems(): FormArray {
//     return this.invoiceForm.get('line_items') as FormArray;
//   }

//   addLineItem(): void {
//     const newItem = this.createLineItem();
//     newItem.patchValue({ item_order: this.lineItems.length + 1 });
//     this.lineItems.push(newItem);
//   }

//   removeLineItem(index: number): void {
//     if (this.lineItems.length > 1) {
//       this.lineItems.removeAt(index);
//       this.updateItemOrders();
//     }
//   }

//   updateItemOrders(): void {
//     this.lineItems.controls.forEach((control, index) => {
//       control.patchValue({ item_order: index + 1 });
//     });
//   }

//   moveItemUp(index: number): void {
//     if (index > 0) {
//       const item = this.lineItems.at(index);
//       this.lineItems.removeAt(index);
//       this.lineItems.insert(index - 1, item);
//       this.updateItemOrders();
//     }
//   }

//   moveItemDown(index: number): void {
//     if (index < this.lineItems.length - 1) {
//       const item = this.lineItems.at(index);
//       this.lineItems.removeAt(index);
//       this.lineItems.insert(index + 1, item);
//       this.updateItemOrders();
//     }
//   }

//   setupCalculations(): void {
//     this.invoiceForm.valueChanges.subscribe(() => {
//       this.calculateTotals();
//     });
//   }

//   calculateLineItemAmount(item: any): number {
//     const quantity = parseFloat(item.quantity) || 0;
//     const rate = parseFloat(item.rate) || 0;
//     const discountStr = item.discount || '0';
    
//     let amount = quantity * rate;
    
//     if (discountStr.includes('%')) {
//       const discountPercent = parseFloat(discountStr.replace('%', '')) || 0;
//       amount = amount * (1 - discountPercent / 100);
//     } else {
//       const discountAmount = parseFloat(discountStr) || 0;
//       amount = amount - discountAmount;
//     }
    
//     return amount;
//   }

//   calculateTotals(): any {
//     const formValue = this.invoiceForm.value;
//     let subTotal = 0;

//     // Calculate subtotal
//     formValue.line_items.forEach((item: any) => {
//       subTotal += this.calculateLineItemAmount(item);
//     });

//     // Calculate discount
//     let discountAmount = 0;
//     if (formValue.discount_type === 'percent') {
//       discountAmount = subTotal * (formValue.discount / 100);
//     } else {
//       discountAmount = formValue.discount || 0;
//     }

//     const afterDiscount = subTotal - discountAmount;

//     // Calculate TDS/TCS
//     const tdsAmount = parseFloat(formValue.tds) || 0;
//     const tcsAmount = parseFloat(formValue.tcs) || 0;

//     // Calculate adjustment
//     const adjustmentAmount = parseFloat(formValue.adjustment) || 0;

//     // Calculate total
//     const total = afterDiscount - tdsAmount + tcsAmount + adjustmentAmount;

//     return {
//       subTotal: subTotal.toFixed(2),
//       discountAmount: discountAmount.toFixed(2),
//       tdsAmount: tdsAmount.toFixed(2),
//       tcsAmount: tcsAmount.toFixed(2),
//       adjustmentAmount: adjustmentAmount.toFixed(2),
//       total: total.toFixed(2)
//     };
//   }

//   get totals() {
//     return this.calculateTotals();
//   }

//   onPaymentTermsChange(event: any): void {
//     const days = parseInt(event.target.value);
//     const dueDate = this.getDueDate(days);
//     this.invoiceForm.patchValue({ due_date: dueDate });
//   }

//   getCurrentDate(): string {
//     const today = new Date();
//     return today.toISOString().split('T')[0];
//   }

//   getDueDate(days: number): string {
//     const today = new Date();
//     today.setDate(today.getDate() + days);
//     return today.toISOString().split('T')[0];
//   }

//   onSubmit(): void {
//     if (this.invoiceForm.valid) {
//       const payload = this.buildPayload();
//       console.log('Invoice Payload:', payload);
//       // Call your API service here to submit the invoice
//       // this.invoiceService.createInvoice(payload).subscribe(...)
//     } else {
//       this.markFormGroupTouched(this.invoiceForm);
//       alert('Please fill all required fields');
//     }
//   }

//   buildPayload(): InvoicePayload {
//     const formValue = this.invoiceForm.value;
    
//     return {
//       invoice_number: formValue.invoice_number,
//       reference_number: formValue.reference_number,
//       payment_terms: formValue.payment_terms,
//       payment_terms_label: this.getPaymentTermsLabel(formValue.payment_terms),
//       payment_options: {
//         payment_gateways: []
//       },
//       customer_id: formValue.customer_id,
//       contact_persons: formValue.contact_persons,
//       date: formValue.date,
//       due_date: formValue.due_date,
//       notes: formValue.notes,
//       terms: formValue.terms,
//       is_inclusive_tax: formValue.is_inclusive_tax,
//       line_items: formValue.line_items.map((item: any, index: number) => ({
//         item_order: index + 1,
//         rate: item.rate,
//         description: item.description,
//         quantity: item.quantity,
//         discount: item.discount,
//         tax_id: item.tax_id,
//         project_id: item.project_id,
//         tags: item.tags,
//         tax_exemption_code: item.tax_exemption_code,
//         item_custom_fields: item.item_custom_fields,
//         hsn_or_sac: item.hsn_or_sac,
//         gst_treatment_code: item.gst_treatment_code
//       })),
//       allow_partial_payments: formValue.allow_partial_payments,
//       custom_fields: [],
//       account_id: formValue.account_id,
//       is_discount_before_tax: formValue.is_discount_before_tax,
//       discount: formValue.discount,
//       discount_type: 'entity_level',
//       adjustment: formValue.adjustment,
//       adjustment_description: formValue.adjustment_description,
//       tax_exemption_code: '',
//       tax_authority_name: '',
//       zcrm_potential_id: '',
//       zcrm_potential_name: '',
//       pricebook_id: '',
//       template_id: formValue.template_id,
//       project_id: '',
//       documents: [],
//       mail_attachments: [],
//       billing_address_id: formValue.billing_address_id,
//       shipping_address_id: formValue.shipping_address_id,
//       gst_treatment: formValue.gst_treatment,
//       gst_no: formValue.gst_no,
//       place_of_supply: formValue.place_of_supply,
//       subject_content: formValue.subject_content,
//       is_tcs_amount_in_percent: formValue.is_tcs_amount_in_percent
//     };
//   }

//   getPaymentTermsLabel(days: number): string {
//     const option = this.paymentTermsOptions.find(opt => opt.value === days);
//     return option ? option.label : `Net ${days}`;
//   }

//   markFormGroupTouched(formGroup: FormGroup | FormArray): void {
//     Object.keys(formGroup.controls).forEach(key => {
//       const control = formGroup.get(key);
//       control?.markAsTouched();

//       if (control instanceof FormGroup || control instanceof FormArray) {
//         this.markFormGroupTouched(control);
//       }
//     });
//   }

//   onCancel(): void {
//     if (confirm('Are you sure you want to cancel? All unsaved changes will be lost.')) {
//       this.invoiceForm.reset();
//       // this.ngOnInit();
//     }
//   }
// }

import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
interface LineItem {
  item_order: number;
  rate: string;
  description: string;
  quantity: string;
  discount: string;
  tax_id: string;
  project_id: string;
  tags: string[];
  tax_exemption_code: string;
  item_custom_fields: any[];
  hsn_or_sac: string;
  gst_treatment_code: string;
}

interface InvoicePayload {
  invoice_number: string;
  reference_number: string;
  payment_terms: number;
  payment_terms_label: string;
  payment_options: {
    payment_gateways: any[];
  };
  customer_id: string;
  contact_persons: string[];
  date: string;
  due_date: string;
  notes: string;
  terms: string;
  is_inclusive_tax: boolean;
  line_items: LineItem[];
  allow_partial_payments: boolean;
  custom_fields: any[];
  account_id: string;
  is_discount_before_tax: boolean;
  discount: number;
  discount_type: string;
  adjustment: string;
  adjustment_description: string;
  tax_exemption_code: string;
  tax_authority_name: string;
  zcrm_potential_id: string;
  zcrm_potential_name: string;
  pricebook_id: string;
  template_id: string;
  project_id: string;
  documents: any[];
  mail_attachments: any[];
  billing_address_id: string;
  shipping_address_id: string;
  gst_treatment: string;
  gst_no: string;
  place_of_supply: string;
  subject_content: string;
  is_tcs_amount_in_percent: boolean;
}

@Component({
  selector: 'app-admin-generate-invoice',
  templateUrl: './admin-generate-invoice.component.html',
  styleUrls: ['./admin-generate-invoice.component.css']
})
export class AdminGenerateInvoiceComponent implements OnInit {
  invoiceForm!: FormGroup;
  
  // Dropdown options
  paymentTermsOptions = [
    { value: 15, label: 'Net 15' },
    { value: 30, label: 'Net 30' },
    { value: 45, label: 'Net 45' },
    { value: 60, label: 'Net 60' }
  ];

  accountOptions = [
    { value: '3091886000000000462', label: 'Accounts Receivable' }
  ];

  taxOptions = [
    { value: '3091886000000032437', label: 'GST 18%' },
    { value: '', label: 'No Tax' }
  ];

  gstTreatmentOptions = [
    { value: 'consumer', label: 'Consumer' },
    { value: 'business_gst', label: 'Business - GST' },
    { value: 'business_none', label: 'Business - None' }
  ];

  placeOfSupplyOptions = [
    { value: 'TS', label: 'Telangana' },
    { value: 'AP', label: 'Andhra Pradesh' },
    { value: 'KA', label: 'Karnataka' },
    { value: 'TN', label: 'Tamil Nadu' }
  ];

  constructor(
    public MatDialogRef: MatDialogRef<AdminGenerateInvoiceComponent>,
    // private matdialogref: MatDialogRef<AdminGenerateInvoiceComponent>,
    // private adminService: AdminService,
    // private snackBar: MatSnackBar
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.initializeForm();
    this.setupCalculations();
  }

  initializeForm(): void {
    this.invoiceForm = this.fb.group({
      customer_id: ['', Validators.required],
      customer_name: ['', Validators.required],
      invoice_number: ['S9T-000003', Validators.required],
      reference_number: [''],
      date: [this.getCurrentDate(), Validators.required],
      payment_terms: [30, Validators.required],
      due_date: [this.getDueDate(30), Validators.required],
      account_id: ['3091886000000000462', Validators.required],
      salesperson: [''],
      subject_content: [''],
      line_items: this.fb.array([this.createLineItem()]),
      notes: ['Thanks for your business with ?'],
      terms: ['exemption certificate available on request.'],
      discount: [0],
      discount_type: ['percent'],
      tds: [0],
      tcs: [0],
      adjustment: [''],
      adjustment_description: ['Adjustment'],
      gst_treatment: ['consumer'],
      gst_no: [''],
      place_of_supply: ['TS'],
      billing_address_id: [''],
      shipping_address_id: [''],
      contact_persons: [[]],
      template_id: ['3091886000000032184'],
      is_inclusive_tax: [false],
      is_discount_before_tax: [true],
      allow_partial_payments: [false],
      is_tcs_amount_in_percent: [true]
    });
  }

  createLineItem(): FormGroup {
    return this.fb.group({
      item_order: [1],
      description: ['', Validators.required],
      quantity: ['1.00', [Validators.required, Validators.min(0.01)]],
      rate: ['0.00', [Validators.required, Validators.min(0)]],
      discount: ['0'],
      tax_id: [''],
      hsn_or_sac: [''],
      project_id: [''],
      tags: [[]],
      tax_exemption_code: [''],
      item_custom_fields: [[]],
      gst_treatment_code: [''],
      amount: [0]
    });
  }

  get lineItems(): FormArray {
    return this.invoiceForm.get('line_items') as FormArray;
  }

  addLineItem(): void {
    const newItem = this.createLineItem();
    newItem.patchValue({ item_order: this.lineItems.length + 1 });
    this.lineItems.push(newItem);
  }

  removeLineItem(index: number): void {
    if (this.lineItems.length > 1) {
      this.lineItems.removeAt(index);
      this.updateItemOrders();
    }
  }

  updateItemOrders(): void {
    this.lineItems.controls.forEach((control, index) => {
      control.patchValue({ item_order: index + 1 });
    });
  }

  moveItemUp(index: number): void {
    if (index > 0) {
      const item = this.lineItems.at(index);
      this.lineItems.removeAt(index);
      this.lineItems.insert(index - 1, item);
      this.updateItemOrders();
    }
  }

  moveItemDown(index: number): void {
    if (index < this.lineItems.length - 1) {
      const item = this.lineItems.at(index);
      this.lineItems.removeAt(index);
      this.lineItems.insert(index + 1, item);
      this.updateItemOrders();
    }
  }

  setupCalculations(): void {
    this.invoiceForm.valueChanges.subscribe(() => {
      this.calculateTotals();
    });
  }

  calculateLineItemAmount(item: any): number {
    const quantity = parseFloat(item.quantity) || 0;
    const rate = parseFloat(item.rate) || 0;
    const discountStr = item.discount || '0';
    
    let amount = quantity * rate;
    
    if (discountStr.includes('%')) {
      const discountPercent = parseFloat(discountStr.replace('%', '')) || 0;
      amount = amount * (1 - discountPercent / 100);
    } else {
      const discountAmount = parseFloat(discountStr) || 0;
      amount = amount - discountAmount;
    }
    
    return amount;
  }

  calculateTotals(): any {
    const formValue = this.invoiceForm.value;
    let subTotal = 0;

    // Calculate subtotal
    formValue.line_items.forEach((item: any) => {
      subTotal += this.calculateLineItemAmount(item);
    });

    // Calculate discount
    let discountAmount = 0;
    if (formValue.discount_type === 'percent') {
      discountAmount = subTotal * (formValue.discount / 100);
    } else {
      discountAmount = formValue.discount || 0;
    }

    const afterDiscount = subTotal - discountAmount;

    // Calculate TDS/TCS
    const tdsAmount = parseFloat(formValue.tds) || 0;
    const tcsAmount = parseFloat(formValue.tcs) || 0;

    // Calculate adjustment
    const adjustmentAmount = parseFloat(formValue.adjustment) || 0;

    // Calculate total
    const total = afterDiscount - tdsAmount + tcsAmount + adjustmentAmount;

    return {
      subTotal: subTotal.toFixed(2),
      discountAmount: discountAmount.toFixed(2),
      tdsAmount: tdsAmount.toFixed(2),
      tcsAmount: tcsAmount.toFixed(2),
      adjustmentAmount: adjustmentAmount.toFixed(2),
      total: total.toFixed(2)
    };
  }

  get totals() {
    return this.calculateTotals();
  }

  onPaymentTermsChange(event: any): void {
    const days = parseInt(event.value);
    const dueDate = this.getDueDate(days);
    this.invoiceForm.patchValue({ due_date: dueDate });
  }

  getCurrentDate(): string {
    const today = new Date();
    return today.toISOString().split('T')[0];
  }

  getDueDate(days: number): string {
    const today = new Date();
    today.setDate(today.getDate() + days);
    return today.toISOString().split('T')[0];
  }

  onSubmit(): void {
    if (this.invoiceForm.valid) {
      const payload = this.buildPayload();
      console.log('Invoice Payload:', payload);
      // Call your API service here to submit the invoice
      // this.invoiceService.createInvoice(payload).subscribe(...)
    } else {
      this.markFormGroupTouched(this.invoiceForm);
      alert('Please fill all required fields');
    }
  }

  buildPayload(): InvoicePayload {
    const formValue = this.invoiceForm.value;
    
    return {
      invoice_number: formValue.invoice_number,
      reference_number: formValue.reference_number,
      payment_terms: formValue.payment_terms,
      payment_terms_label: this.getPaymentTermsLabel(formValue.payment_terms),
      payment_options: {
        payment_gateways: []
      },
      customer_id: formValue.customer_id,
      contact_persons: formValue.contact_persons,
      date: formValue.date,
      due_date: formValue.due_date,
      notes: formValue.notes,
      terms: formValue.terms,
      is_inclusive_tax: formValue.is_inclusive_tax,
      line_items: formValue.line_items.map((item: any, index: number) => ({
        item_order: index + 1,
        rate: item.rate,
        description: item.description,
        quantity: item.quantity,
        discount: item.discount,
        tax_id: item.tax_id,
        project_id: item.project_id,
        tags: item.tags,
        tax_exemption_code: item.tax_exemption_code,
        item_custom_fields: item.item_custom_fields,
        hsn_or_sac: item.hsn_or_sac,
        gst_treatment_code: item.gst_treatment_code
      })),
      allow_partial_payments: formValue.allow_partial_payments,
      custom_fields: [],
      account_id: formValue.account_id,
      is_discount_before_tax: formValue.is_discount_before_tax,
      discount: formValue.discount,
      discount_type: 'entity_level',
      adjustment: formValue.adjustment,
      adjustment_description: formValue.adjustment_description,
      tax_exemption_code: '',
      tax_authority_name: '',
      zcrm_potential_id: '',
      zcrm_potential_name: '',
      pricebook_id: '',
      template_id: formValue.template_id,
      project_id: '',
      documents: [],
      mail_attachments: [],
      billing_address_id: formValue.billing_address_id,
      shipping_address_id: formValue.shipping_address_id,
      gst_treatment: formValue.gst_treatment,
      gst_no: formValue.gst_no,
      place_of_supply: formValue.place_of_supply,
      subject_content: formValue.subject_content,
      is_tcs_amount_in_percent: formValue.is_tcs_amount_in_percent
    };
  }

  getPaymentTermsLabel(days: number): string {
    const option = this.paymentTermsOptions.find(opt => opt.value === days);
    return option ? option.label : `Net ${days}`;
  }

  markFormGroupTouched(formGroup: FormGroup | FormArray): void {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      control?.markAsTouched();

      if (control instanceof FormGroup || control instanceof FormArray) {
        this.markFormGroupTouched(control);
      }
    });
  }

  onCancel(): void {
    if (confirm('Are you sure you want to cancel? All unsaved changes will be lost.')) {
      this.invoiceForm.reset();
      this.ngOnInit();
    }
  }
  close() {
    this.MatDialogRef.close();
  }
}